/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ConnectivityType {
    AWS_IOT = 'AWS_IOT'
}


export function ConnectivityTypeFromJSON(json: any): ConnectivityType {
    return ConnectivityTypeFromJSONTyped(json, false);
}

export function ConnectivityTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConnectivityType {
    return json as ConnectivityType;
}

export function ConnectivityTypeToJSON(value?: ConnectivityType | null): any {
    return value as any;
}

